<template>
  <Modal v-model="model" :title="title" @on-cancel="cancel" sticky reset-drag-position scrollable :mask="false" draggable class="public_pop insert_edit_pop" :styles="modelHeight"  width="800">
    <Spin size="large" fix v-if="spinShow"></Spin>
    <Form ref="addEditColumn" label-colon class="form_submit_pop" :show-message="showMessage" :model="addEditColumn" :rules="ruleValidate">
      <FormItem :label="item.customName" :prop="item.customColName" :title="item.customName" v-if="(openState=='0' && item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime'
        && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status') || openState=='1'" v-for="(item,index) in addEditColumn.allColumnInfo"
        :key="index" :class="{'formDefinedClass':item.type=='file' || item.type=='textarea'}">
        <Input v-if="item.type=='text'" v-model="item.popCustomValue" :disabled="item.customIsAlter!='1'"/>

        <Input v-if="item.type=='textarea'" type="textarea" :rows="3" v-model="item.popCustomValue" :disabled="item.customIsAlter!='1'"/>

        <DatePicker type="datetime" v-if="item.type=='datetime'" transfer :disabled="item.customIsAlter!='1'" format="yyyy-MM-dd HH:mm:ss" placement="bottom-start" :editable="editable" v-model="item.popCustomValue"></DatePicker>

        <Select v-if="item.type=='select' || item.type=='radio'" transfer clearable v-model="item.popCustomValue"  :disabled="item.customIsAlter!='1'">
          <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
        </Select>

        <Select v-if="item.type=='checkbox'" clearable multiple transfer :max-tag-count="2" v-model="item.popCustomValue"  :disabled="item.customIsAlter!='1'">
          <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
        </Select>

        <el-cascader v-if="item.type=='cascade'" v-model="item.popCustomValue" :placeholder="item.customName" clearable  :disabled="item.customIsAlter!='1'" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

        <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.popCustomValue" :disabled="item.customIsAlter!='1'"/>

        <File v-if="item.type=='file'" @fileUploadCallback="fileUploadCallback" v-model="item.popCustomValue" :showFilelist= "true"/>
      </FormItem>
      
      
    </Form>
    <div class="btn_template" slot="footer">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()" :loading="loading">保存</Button>
      </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublic} from '@/components/js/CustomerPublic.js'
    import File from '@/components/customerMange/File.vue'
    export default {
        name: "InsertCustomerPop",
        mixins:[publicFunClass,customerPublic],
        props: {
          showInsertPop:Boolean,
          showCustomerTitle:String,
          journalType:String,
          menuId:String,
          searchId:String,
          customerScope:String,
          formValidate:Object
        },
        components:{
          File
        },
        data(){
          return {
            model:false,
            spinShow:true,
            editable:false,
            showMessage:false,
            title:'添加客户',
            addEditColumn:{},
            modelHeight:{'maxHeight':'','marginTop':'0px'},
            currentColName:'',
            ruleValidate: {},
            openState:'',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
            loading:false,
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeInsertCustomer",false);
          },
          save:function () {
            let that=this;
            this.spinShow=true;
            let param={
              journalType:this.journalType,
              menuId:this.menuId,
              customerScope:this.customerScope,
              customerState:this.addEditColumn.customerState
            };
            let allColumnInfo=this.addEditColumn.allColumnInfo;
            let phoneIsHide= that.configInfo.phoneIsHide;

            for (let i=0;i<allColumnInfo.length;i++){
              let customName = allColumnInfo[i].customName;
              let popCustomValue=allColumnInfo[i].popCustomValue;//右侧的值  附件此处要去地址对应的值 描述对应的值
              let customColName=allColumnInfo[i].customColName;//左侧的名称  附件此个则为file30
              if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1){
                let oldValue=allColumnInfo[i].oldValue;
                if(phoneIsHide=='1' && oldValue==popCustomValue){
                  popCustomValue=allColumnInfo[i].autoValue;
                }
              }
              let type=allColumnInfo[i].type;
              if (!popCustomValue || popCustomValue.length==0){
                popCustomValue="";
              }
              if(type=="cascade" && popCustomValue.length>0){
                popCustomValue=popCustomValue.toString();
              }
              if(type=="datetime" && popCustomValue){
                popCustomValue=this.timeChange(popCustomValue);
              }
              if(type == "file" && popCustomValue){
                // 如果下载地址是空的，保存时去除这行数据
                let fileJson = JSON.parse(popCustomValue);
                let newFlag = 0;
                for(let n = 0; n < fileJson.length; ){
                  newFlag++;
                  if (!fileJson[n].downloadAddr){
                    fileJson.splice(n,1);
                  }else if(!fileJson[n].description){
                    that.$Modal.info({
                      title: '提示',
                      content: ""+customName+"的第"+newFlag+"个附件已上传成功，但对应备注为空，请确认后重试"
                    });
                    this.spinShow=false;
                    return false;
                  }else{
                    n++;
                  }
                }
                popCustomValue = JSON.stringify(fileJson);
              }
              param[allColumnInfo[i].customColName]=popCustomValue;
            }
            let url="customer/insertCustomer.json";
            if(this.searchId){
              param.id=this.searchId;
              url="customer/updateCustomer.json";
            }
            if(!param["customerManager"] && "0" == param["customerScope"]){
              param["customerManager"] = this.agentInfo.employeeId;
            }
            this.loading = true;
            this.$http.post(url,param) .then(function (res) {
              that.spinShow=false;
              that.loading=false; 
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              that.$Modal.info({
                title: '提示',
                content: "操作成功"
              });
              that.$emit("closeInsertCustomer",true);
            });
          },
          initSearch:function () {
            let that=this;
            this.spinShow=true;
            let param={
              id:this.searchId,
              customerScope:this.customerScope,
              journalType:"null",
              menuId:"null",
              selectCount:false,
              pageNum:1,
              pageSize:10
            };
            this.$http.post("customer/selectAllCustomer.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let contentList=res.data.obj.list.content;
              let allColumnInfo=that.addEditColumn.allColumnInfo;
              let phoneIsHide= that.configInfo.phoneIsHide;
              for (let key in contentList[0]){
                let value=contentList[0][key];
                for (let i=0;i<allColumnInfo.length;i++){
                  let customColName=allColumnInfo[i].customColName;
                  let type=allColumnInfo[i].type;
                  if(customColName==key){
                    that.addEditColumn.allColumnInfo[i].popCustomValue=value;
                    if(type=='checkbox' || type=='radio' || type=='select' || type =='cascade'){
                      that.addEditColumn.allColumnInfo[i].popCustomValue=contentList[0][key+"Id"];
                    }
                    if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1){
                      if(phoneIsHide=='1'){
                        that.addEditColumn.allColumnInfo[i].popCustomValue=contentList[0][key+'Hide'];
                        that.addEditColumn.allColumnInfo[i]["oldValue"]=contentList[0][key+'Hide'];
                        that.addEditColumn.allColumnInfo[i]["autoValue"]=contentList[0][key];
                      }
                    }
                  }

                }
              }
            });
          },
          // 上传文件过程中不能保存，调用的接口
          fileUploadCallback(flag){
            if(flag || flag == 'true'){
              this.loading = true;
            }else{
              this.loading = false;
            }
          }
        },
        created(){
          this.modelHeight.maxHeight=this.mountHeight(150);
        },
        mounted(){
          
        },
        watch:{
          showInsertPop:function () {
            this.model=this.showInsertPop;
            this.title=this.showCustomerTitle;
            let formValidate=this.formValidate;
            this.ruleValidate={};
            this.addEditColumn={};
            this.spinShow=true;
            if(this.showInsertPop){
              for (let i=0;i<formValidate.allColumnInfo.length;i++){
                formValidate.allColumnInfo[i].popCustomValue="";
                if(formValidate.allColumnInfo[i].type =='cascade'){
                  formValidate.allColumnInfo[i].popCustomValue=[];
                }
                let customIsMust=formValidate.allColumnInfo[i].customIsMust;
                let customColName=formValidate.allColumnInfo[i].customColName;
                let popCustomValue=formValidate.allColumnInfo[i].popCustomValue;
                if(popCustomValue=='' && customColName=='customerManager'){
                  let agentInfo=JSON.parse(localStorage.getItem("agentInfo"));
                  formValidate.allColumnInfo[i].popCustomValue=agentInfo.employeeId;
                }
                let list= [{ required: true}];
                if(customIsMust=='1'){
                  this.ruleValidate[customColName]=list;
                }
              }
              this.addEditColumn=formValidate;
              if(!this.searchId){
                this.spinShow=false;
              }
              this.openState="0";//添加时
              if(this.searchId){
                this.initSearch();
                this.openState="1";//编辑时
              }
            }

          }
        }
    }
</script>
<style scoped>
.formDefinedClass{
  width: 100% !important;
}
.formDefinedClass /deep/ .ivu-form-item-label{
  width: 15% !important;
}
.formDefinedClass /deep/ .ivu-form-item-content{
  width: 85% !important;
}

.formDefinedClass /deep/ .ivu-input-type-textarea{
  height: auto !important;
}
/* 此部分可以限制添加框的高度固定
.public_pop /deep/ .ivu-modal-content {
    top:20px !important;
}
*/
.public_pop /deep/ .ivu-modal-body {
    max-height: 550px;
    overflow-y: auto !important;
}
.public_pop .btn_template{
    text-align: center;
    margin-bottom: 0px !important;
  }
  .public_pop .submit_btn{
      height: 25px;
    }
    .cancel_btn{
      height: 25px;
    }
</style>





// WEBPACK FOOTER //
// src/components/customerMange/InsertCustomerPop.vue